import React, { Component } from "react";
import PropTypes from "prop-types";
import { toJS } from "mobx";
import { Button } from "arv-reactcomponents";
import {
  Says,
  Returns,
  About,
  FinerDetails,
} from "../Desktop/accordionContents";
import Analytics from "../../../analytics";
import Event from "../../../analytics/eventFactory";

class PdpMobileAccordion extends Component {
  static activeButton(isOpen) {
    return isOpen ? "is-active" : "";
  }
  static getActiveAccordion(type, PdpData) {
    switch (type) {
      case "says":
        return <Says PdpData={PdpData} className="nw-mobileaccordion-view" />;
      case "returns":
        return (
          <Returns PdpData={PdpData} className="nw-mobileaccordion-view" />
        );
      case "about":
        return <About PdpData={PdpData} className="nw-mobileaccordion-view" />;
      case "details":
        return (
          <FinerDetails PdpData={PdpData} className="nw-mobileaccordion-view" />
        );
      default:
        return <div />;
    }
  }

  constructor(props) {
    super(props);

    this.state = {
      buttons: [],
    };
    this.buttons = [
      {
        type: "details",
        text: "THE FINER DETAILS",
        isOpen: false,
      },
      {
        type: "about",
        text: "",
        isOpen: false,
      },
      {
        type: "returns",
        text: "RETURNS & EXCHANGES",
        isOpen: false,
      },
      {
        type: "says",
        text: "NNNOW SAYS",
        isOpen: false,
      },
    ];
    this.setActive = this.setActive.bind(this);
    this.revampAccordion = this.revampAccordion.bind(this);
  }
  componentDidMount() {
    this.revampAccordion(this.props);
  }
  componentWillReceiveProps(nextProps) {
    this.revampAccordion(nextProps);
  }

  setActive(event, button) {
    event.preventDefault();
    const toggle = button;
    toggle.isOpen = !toggle.isOpen;
    this.setState({});
    Analytics.trackEvent({
      action: Event.action.getTabClicked(toggle.type),
      category: Event.category.PRODUCT_DESCRIPTION_PAGE,
    });
  }

  componentDidCatch(error, info) {
    console.log(this, error, info);
  }

  revampAccordion(nextProps) {
    const { PdpData } = nextProps;
    const { mainStyle } = PdpData;
    let { finerDetails = {}, about, returnable, story } = toJS(mainStyle);
    const buttons = this.buttons.slice();
    let index = 0;
    if (!finerDetails) finerDetails = {};
    if (finerDetails && !Object.keys(finerDetails).length) {
      index = buttons.findIndex(button => button.type === "details");
      buttons.splice(index, 1);
    }
    if (!about) {
      index = buttons.findIndex(button => button.type === "about");
      buttons.splice(index, 1);
    }
    if (!(returnable === true || returnable === false)) {
      index = buttons.findIndex(button => button.type === "returns");
      buttons.splice(index, 1);
    }
    if (!story) {
      index = buttons.findIndex(button => button.type === "says");
      buttons.splice(index, 1);
    }
    index = buttons.findIndex(button => button.type === "about");
    if (index > -1) {
      const { brandName } = about;
      const aboutBrand = `ABOUT ${brandName}`;
      buttons[index].text = aboutBrand;
    }
    this.setState({ buttons });
  }
  render() {
    return (
      <div className="nw-pdp-mobileaccordionwrap nw-mobile-only">
        <div className="nw-pdp-mobileaccordionbuttonwrap">
          {this.state.buttons.map(button => (
            <div key={button.type}>
              <Button
                className={`nw-pdp-mobileaccordionbutton ${PdpMobileAccordion.activeButton(
                  button.isOpen,
                )}`}
                onClick={e => this.setActive(e, button)}
              >
                <i
                  className={`icomoon-arrow_right nw-mobileaccordion-rightarrow ${PdpMobileAccordion.activeButton(
                    button.isOpen,
                  )}`}
                />
                <span>{button.text}</span>
              </Button>
              <div
                className={`nw-pdp-mobileaccordionbuttoncontent ${PdpMobileAccordion.activeButton(
                  button.isOpen,
                )}`}
              >
                {PdpMobileAccordion.getActiveAccordion(
                  button.type,
                  this.props.PdpData,
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}
PdpMobileAccordion.propTypes = {
  PdpData: PropTypes.shape({
    mainStyle: PropTypes.shape({
      about: PropTypes.shape({
        brandName: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};
export default PdpMobileAccordion;



// WEBPACK FOOTER //
// ./src/component/PdpAccordion/Mobile/index.js